import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoginPage from '@/pages/Login/LoginPage';
import EmpresaSelectionPage from '@/pages/Empresas/EmpresaSelectionPage';
import ClientesPage from '@/pages/Clientes/ClientesPage';
import ClienteDetailPage from '@/pages/Clientes/ClienteDetailPage';
import CatalogoPage from '@/pages/Catalogo/CatalogoPage';
import CarritoPage from '@/pages/Carrito/CarritoPage';
import PedidosPage from '@/pages/Pedidos/PedidosPage';
import PedidoDetailPage from '@/pages/Pedidos/PedidoDetailPage';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { useAuthStore } from '@/store/authStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/clientes" replace /> : <LoginPage />}
          />
          <Route
            path="/empresas"
            element={
              <ProtectedRoute>
                <EmpresaSelectionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes"
            element={
              <ProtectedRoute>
                <ClientesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/:id"
            element={
              <ProtectedRoute>
                <ClienteDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalogo"
            element={
              <ProtectedRoute>
                <CatalogoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/carrito"
            element={
              <ProtectedRoute>
                <CarritoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finalizar-pedido"
            element={
              <ProtectedRoute>
                <Navigate to="/carrito" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pedidos"
            element={
              <ProtectedRoute>
                <PedidosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pedidos/:id"
            element={
              <ProtectedRoute>
                <PedidoDetailPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/clientes" replace />} />
          <Route path="*" element={<Navigate to="/clientes" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
